import { fromPromise } from 'xstate5';

import { checkIfShouldShowLocationWarning } from '../../../services';
import { type Location } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfShouldShowPickupLocationWarningActor = fromPromise(
  async ({ input }: { input: LocationWarningActorInput }) =>
    checkIfShouldShowLocationWarning(input.activeLocation),
);

export const checkIfShouldShowOutpostLocationWarningActor = fromPromise(
  async ({ input }: { input: LocationWarningActorInput }) =>
    checkIfShouldShowLocationWarning(input.activeLocation),
);

// ─── Types ───────────────────────────────────────────────────────────────────

export type LocationWarningActorInput = {
  activeLocation: Location | undefined;
};
